<template>
  <div ref="chartWrapper"
       class="widget-wrapper"
  >
    <div ref="chartWrapperOpts"
         class="widget-contents-option"
    >
      <div style="flex: 1"></div>
      <q-select style="width: 80px;"
                class="bs bs-q-sm bs-q-select bs-q-select-default"
                :value="opts.unit"
                :options="sortByOptions"
                :auth-force="true"
                @change="onChangeChartOptions"
      />
    </div>
    <div class="widget-contents">
      <div class="widget-contents-wrapper">
        <trend-chart ref="chartInstance"
                     class="widget-contents-chart"
                     :grid="{ left: '55px', right: '1%'}"
                     :data="widgetData"
                     :x-axis="xAxis"
                     :y-axis="yAxis"
                     :series="series"
                     :tooltip="tooltip"
                     :zoom="true"
        />
      </div>
    </div>

    <!--팝업 - 동적 컴포넌트-->
    <component v-bind:is="renderPopUpComponent"
               :id='vlanId'
               @confirm="onConfirmVlan" />
  </div>
</template>
<script>
  // Mixin 객체
  import {widgetMixin} from '~/mixins/widgetCommonMixin'
  // 스토어 헬퍼
  import {createNamespacedHelpers} from 'vuex'
  // 스토어 헬퍼 객체
  const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetSysVlanTraffic',
    directives: {},
    mixins: [widgetMixin],
    data () {
      return {
        w: 2,
        self: this,
        opts: {
          vlanId: -1,
          unit: 'bps'
        },
        title: 'widgetSysVlanTraffic',
        isVlan: true,
        isLock: false,
        isMove: true,
        isResize: true,
        eventBus: true,
        deviceType: [20],
        restData: {
          result: [],
          unit_time: ''
        },
        widgetData: [],
        timerValue: 10000,
        timerObject: null,
        lastEndTime: '',
        // TAMS
        autoAlignTimer: void 0,
        series: [
          { id: 'anVlanTxMin', type: 'line', name: 'Min', smooth: 0.6, symbol: 'circle', showSymbol: false, triggerLineEvent: true },
          { id: 'anVlanRxMin', type: 'line', name: 'Min', smooth: 0.6, symbol: 'circle', showSymbol: false, triggerLineEvent: true },
          { id: 'anVlanTxAvg', type: 'line', name: 'Avg', smooth: 0.6, symbol: 'circle', showSymbol: false, triggerLineEvent: true },
          { id: 'anVlanRxAvg', type: 'line', name: 'Avg', smooth: 0.6, symbol: 'circle', showSymbol: false, triggerLineEvent: true },
          { id: 'anVlanTxMax', type: 'line', name: 'Max', smooth: 0.6, itemStyle: {color: '#e145e3'}, symbol: 'circle', showSymbol: false, triggerLineEvent: true },
          { id: 'anVlanRxMax', type: 'line', name: 'Max', smooth: 0.6, itemStyle: {color: '#e145e3'}, symbol: 'circle', showSymbol: false, triggerLineEvent: true }
        ],
        xAxisRawData: {
          type: 'time',
          axisLine: {onZero: true},
          axisLabel: {
            formatter: '{HH}:{mm}:{ss}  ',
            hideOverlap: true
          }
        },
        yAxisRawData: [
          {
            name: 'In',
            max: 1,
            min: -1,
            type: 'value',
            position: 'left',
            axisLabel: {
              formatter: value => this.opts.unit === 'bps' ? this.bpsConverter(Math.abs(value)) : this.ppsConverter(Math.abs(value))
            },
            nameLocation: 'center',
            nameRotate: 0,
            nameGap: 80,
            nameTextStyle: {
              verticalAlign: 'bottom',
              lineHeight: this.isMaximumWidget ? 400 : 80
            }
          },
          {
            name: 'Out',
            type: 'value',
            position: 'left',
            nameLocation: 'center',
            nameRotate: 0,
            nameGap: 80,
            nameTextStyle: {
              verticalAlign: 'top',
              lineHeight: this.isMaximumWidget ? 400 : 80
            }
          }
        ]
      }
    },
    computed: {
      vlanId () {
        return _.isNil(this.opts.vlanId) ? -1 : this.opts.vlanId
      },
      xAxis: {
        get () {
          return this.xAxisRawData
        },
        set (options) {
          this.xAxisRawData = options
        }
      },
      yAxis: {
        get () {
          return this.yAxisRawData
        },
        set (options) {
          this.yAxisRawData = options
        }
      },
      tooltip () {
        return {
          axisPointer: {type: 'line'},
          formatter: (params) => {
            const dictLabelName = {
              'anVlanTxMin': 'Min (Tx)',
              'anVlanRxMin': 'Min (Rx)',
              'anVlanTxAvg': 'Avg (Tx)',
              'anVlanRxAvg': 'Avg (Rx)',
              'anVlanTxMax': 'Max (Tx)',
              'anVlanRxMax': 'Max (Rx)'
            }
            let resFormat = `<b>${params[0].axisValueLabel.split(' ')[1]}</b><br>`
            for (let i = 0, max = params.length; i < max; i++) {
              const traffic = Math.abs(params[i].value[1])
              const seriesName = _.get(dictLabelName, [params[i].seriesId], '')
              resFormat += `${params[i].marker}${seriesName} : <b>${this.opts.unit === 'bps' ? this.bpsConverter(traffic) : this.ppsConverter(traffic)}</b><br>`
            }
            return resFormat
          }
        }
      },
      sortByOptions () {
        return [
          {
            label: 'bps',
            value: 'bps'
          },
          {
            label: 'pps',
            value: 'pps'
          }
        ]
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {},
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {
      // 랜더링 이후 차트 중앙정렬 타이머
      if (this.autoAlignTimer) {
        clearTimeout(this.autoAlignTimer)
      }

      // 셀프 객체 초기화
      this.self = null
    },
    destroyed () {},
    errorCaptured () {},
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      setYAxisMaxValue () {
        const chart = this.$refs.chartInstance
        const {dataMax, dataMin} = chart.yAxis[0].getExtremes()
        let allMaxValue = (dataMax > Math.abs(dataMin)) ? dataMax : Math.abs(dataMin)
        allMaxValue = (allMaxValue === 0) ? 100 : allMaxValue * 1.1

        // chart.yAxis[0].setExtremes(-allMaxValue, allMaxValue)
        chart.yAxis[0].update({
          min: -allMaxValue,
          max: allMaxValue
        })
      },
      /*
        이름: onShowVlanPopUp
        설명: 위젯의 VLAN 선택 창 호출한다.
      */
      onShowVlanPopUp () {
        this.toggleComponent('vlanSelectPopup')
      },
      async onConfirmVlan ({ vlanId }) {
        this.opts.vlanId = vlanId
        this.getWidgetContentsData(true, { vlanId })
      },
      async onChangeChartOptions (value) {
        this.opts.unit = value
        this.getWidgetContentsData(true)
      },
      // 위젯 대상 장비 필터 설정.
      async onChangeWidgetMachId ({ machId }) {
        // 위젯 옵션 변경 - 저장에 필요한 값???
        this.opts.mach_id = machId
        this.getWidgetContentsData(true, machId)
      },
      async getWidgetContentsData (init = false, extraParams = null) {
        const contentsOptions = {
          vlanId: -1,
          widgetType: 'vlan_traffic_trend'
        }

        if (this.opts.vlanId) {
          contentsOptions.vlanId = this.opts.vlanId
        }

        // 장비 filter 추가
        if (this.opts.mach_id) {
          contentsOptions.machId = this.opts.mach_id
        }

        // 엑스트라 파라미터가 있는 경우 (VLAN ID/Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
        if (extraParams) {
          if (extraParams.vlanId) {
            contentsOptions.vlanId = extraParams.vlanId
            this.$emit('changeVlanId', extraParams.vlanId)
            this.onChangeVlanId(extraParams.vlanId)
          }

          if (extraParams.machId) {
            contentsOptions.machId = extraParams.machId
          }
        }

        // Progress 출력 여부
        this.showProgress(true)

        // initFlag가 True면 기존 차트 데이터 초기
        if (init) {
          // 위젯 데이터 초기화
          this.widgetData = []

          // Series 초기화
          this.$refs.chartInstance.clear()
        }

        // 요청 전 차트 업데이트 처리지정
        // this.allUpdate = init

        // API 호출
        // const {code, eTime, result} = await this.getWidgetData(contentsOptions)
        const {code, result} = await this.getWidgetData(contentsOptions)

        // 마지막 시간 저장 (14:04:59 저장)
        // this.lastEndTime = eTime

        // Series 데이터 구성
        if (code === 'ok' && result.result && _.size(result.result) > 0) {
          // Rest data 초기화
          this.restData = result

          const unit = this.opts.unit === 'bps' ? 'bytes' : 'packets'
          const tx = {min: [], avg: [], max: []}
          const rx = {min: [], avg: [], max: []}
          let maxVal = 0

          // Result 데이터 구성
          for (const trafficData of this.restData.result) {
            maxVal = Math.max(maxVal, _.get(trafficData, `min_tx_${unit}`, 0))
            maxVal = Math.max(maxVal, _.get(trafficData, `min_rx_${unit}`, 0))
            maxVal = Math.max(maxVal, _.get(trafficData, `avg_tx_${unit}`, 0))
            maxVal = Math.max(maxVal, _.get(trafficData, `avg_rx_${unit}`, 0))
            maxVal = Math.max(maxVal, _.get(trafficData, `max_tx_${unit}`, 0))
            maxVal = Math.max(maxVal, _.get(trafficData, `max_rx_${unit}`, 0))

            // TX 입력
            tx.min.push([trafficData.time, _.get(trafficData, `min_tx_${unit}`, 0)])
            tx.avg.push([trafficData.time, _.get(trafficData, `avg_tx_${unit}`, 0)])
            tx.max.push([trafficData.time, _.get(trafficData, `max_tx_${unit}`, 0)])

            // RX 입력
            rx.min.push([trafficData.time, _.get(trafficData, `min_rx_${unit}`, 0)])
            rx.avg.push([trafficData.time, _.get(trafficData, `avg_rx_${unit}`, 0)])
            rx.max.push([trafficData.time, _.get(trafficData, `max_rx_${unit}`, 0)])
          }

          this.yAxis[0].max = maxVal + (maxVal * 0.3) || 1
          this.yAxis[0].min = -maxVal - (maxVal * 0.3) || -1

          this.widgetData = [tx.min, rx.min, tx.avg, rx.avg, tx.max, rx.max]
        } else {
          // TAMS - All update 기준
          // 위젯 데이터 초기화
          this.widgetData = []

          // Series 초기화
          this.$refs.chartInstance.clear()
        }

        // Progress 출력 여부
        this.showProgress(false)
      }
    },
    watch: {}
  }
</script>
<style scoped>
  .widget-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .widget-contents-option {
    right: 0;
    display: flex;
    padding-top: 5px;
    padding-right: 5px;
    margin-bottom: 5px;
  }

  .widget-contents {
    display: flex;
  }

  .widget-contents-wrapper {
    flex-grow: 1;
    display: flex;
    position: relative;
  }

  .widget-contents-option {
    z-index: 10;
    right: 0;
    display: flex;
    position: absolute;
    padding-top: 5px;
    padding-right: 17px;
    margin-bottom: 5px;
  }

  .widget-contents-chart {
    flex-grow: 1 !important;
  }
</style>
